export interface Partner {
  id: string;
  name: string;
}

export interface Site {
  id: string;
  name: string;
}

export interface ForecastFileVersion {
  id: string;
  version: number;
  filename: string;
  status: string;
  userId: string;
  userName: string;
  createdAt: Date | string;
  attachment: {
    id: string;
    filename: string;
    size: number;
    mime: string;
  };
}

export interface ForecastFile {
  id: string;
  filename: string;
  label: string;
  status: string;
  versionsCount: number;
  commentsCount: number;
  createdAt: Date | string;
  updatedAt: Date | string;
  versions: ForecastFileVersion[];
}

export interface ForecastReconciliationItem {
  id: string;
  requesterPartner: Partner;
  supplierPartner: Partner;
  site: Site;
  periodStart: Date | string;
  periodEnd: Date | string;
  status: string;
  filesCount: number;
  createdAt: Date | string;
  updatedAt: Date | string;
  files: ForecastFile[];
}

export interface ForecastReconciliationFilters extends Record<string, unknown> {
  supplierPartnerId?: string;
  siteId?: string;
  periodStart?: string;
  periodEnd?: string;
  status?: string;
  search?: string;
  size?: number;
  page?: number;
  sort?: string;
  direction?: 'ASC' | 'DESC';
}

interface Attachment {
  id: string;
  filename: string;
  size: number;
  mime: string;
}

export interface FileVersion {
  id: string;
  version: number;
  filename: string;
  status: 'draft' | 'published' | 'archived' | 'final';
  userId: string;
  userName: string;
  createdAt: string;
  attachment: Attachment;
}

export interface File {
  id: string;
  filename: string;
  label: string;
  status: 'draft' | 'final';
  versionsCount: number;
  commentsCount: number;
  createdAt: string;
  updatedAt: string;
  versions: FileVersion[];
}

export interface Site {
  id: string;
  name: string;
}

export interface Partner {
  id: string;
  name: string;
}

export interface ForecastFileDetails {
  id: string;
  file: ForecastFile;
  site: Site;
  supplierPartner: Partner;
  periodStart: string | Date;
  status: string;
}
